import { render, staticRenderFns } from "./AnimatedRegion.vue?vue&type=template&id=0410606c&scoped=true"
import script from "./AnimatedRegion.vue?vue&type=script&lang=js"
export * from "./AnimatedRegion.vue?vue&type=script&lang=js"
import style0 from "./AnimatedRegion.vue?vue&type=style&index=0&id=0410606c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0410606c",
  null
  
)

export default component.exports